import styled from "styled-components";

export const Container = styled.div`
	max-width: 100vw;
	min-height: var(--main-height);

	strong {
		color: var(--main-green);
	}

	.social-wrapper {
		h2 {
			font-size: 20px;
		}
		ul {
			display: flex;
			gap: 40px;

			li {
				margin-top: 10px;

				svg {
					font-size: 30px;
				}

				a {
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 10px;
					font-size: 20px;
					color: black;
					transition: 300ms;
				}
				a:hover {
					color: var(--eletric-blue);
					font-weight: 700;
				}
			}
		}
	}

	.Slogan-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.top-content {
		max-width: 100vw;
		display: flex;
		flex-direction: column;
		gap: 25px;

		h1 {
			width: 100%;
			text-align: center;
			font-size: 30px;
			font-weight: bold;

			strong {
				font-size: 30px;
			}
		}

		span {
			text-align: center;
			font-weight: 600;
			font-style: italic;
			font-size: 16px;

			strong {
				font-size: 18px;
				border-radius: 5px;
				padding: 0 10px;
				white-space: nowrap;
			}
		}

		p {
			max-width: 1100px;
			width: 90vw;
			text-align: justify;
		}

		ul {
			display: flex;
			flex-direction: column;
			gap: 10px;

			li {
				list-style-type: upper-roman;
				list-style-position: initial;
				margin-left: 20px;

				p {
					font-size: 18px;
					font-weight: 600;
				}
			}
		}

		.mid_info-area {
			display: flex;
			flex-direction: column;
			gap: 20px;
			li {
				display: flex;
				align-items: center;
				list-style: none;
				margin: 0;
				gap: 10px;

				p {
					font-size: 18px;
					font-weight: 700;
				}

				svg {
					font-size: 25px;
				}
			}
		}
	}

	.info-area {
		max-width: 100vw;
		display: flex;
		flex-direction: column;
		gap: 50px;

		h1 {
			text-align: center;
			font-size: 30px;
			font-weight: bold;

			strong {
				font-size: 30px;
			}
		}

		.block {
			display: flex;
			justify-content: space-between;
			gap: 30px;

			.info {
				display: flex;
				flex-direction: column;
				gap: 30px;

				ul {
					display: flex;
					flex-direction: column;
					gap: 15px;
					li {
						font-size: 18px;
						max-width: 600px;
					}
				}
			}

			h2 {
				display: inline;
				font-size: 24px;
				border-bottom: 3px solid var(--main-green);
				padding: 0 25px 0 0;
			}
		}

		h1 {
			span {
				font-size: 18px;
				border-bottom: 6px solid var(--main-green);
				border-radius: 6px;
				padding: 2px 15px;
			}
		}
	}

	.maps {
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: left;
		gap: 20px;
		iframe {
			align-self: center;
			width: 1000px;
			height: 400px;
			border-radius: 10px;
			-webkit-box-shadow: -2px -1px 20px 3px rgba(60, 255, 150, 0.27);
			-moz-box-shadow: -2px -1px 20px 3px rgba(60, 255, 150, 0.27);
			box-shadow: -2px -1px 20px 3px rgba(60, 255, 150, 0.27);
		}
		a {
			margin-top: 20px;
			text-align: center;
			font-style: italic;
			color: rgb(129, 136, 125);
		}
		a:hover {
			color: rgb(171, 185, 162);
			text-decoration: underline;
		}
	}

	@media (max-width: 899px) {
		.top-content {
			span {
				strong {
					line-height: 30px;
				}
			}
		}

		.info-area {
			max-width: 100vw;
			h3 {
				width: calc(100vw - 5%);
				font-size: 20px;
			}
			.block {
				flex-flow: row wrap;
				align-items: center;
				justify-content: center;

				margin: 0;
				img {
					width: calc(100vw - 80%);
				}
				.info {
					max-width: calc(100vw - 40%);
					div h2 {
						font-size: 20px;
					}
					ul li {
						font-size: 14px;
					}
				}
			}
		}

		.maps {
			width: calc(100vw - 30px);
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin: 0;
			padding: 0;
			h3 {
				align-self: self-start;
			}
			a {
				font-size: 14px;
			}

			iframe {
				width: calc(100vw - 20%);
				height: 330px;
			}
		}
	}

	@media (max-width: 680px) {
		.social-wrapper {
			ul {
				flex-flow: row wrap;
				max-width: 100vw;
				gap: 5px;

				margin-bottom: 20px;
			}
		}

		.Slogan-wrapper {
			img {
				max-width: 80vw;
			}
		}

		.top-content {
			max-width: 100vw;
			p {
				font-size: 14px;
				width: calc(100vw - 5%);
			}

			span {
				strong {
					white-space: normal;
					line-height: 30px;
				}
			}
		}

		.info-area {
			max-width: 100vw;
			h3 {
				width: calc(100vw - 5%);
				font-size: 20px;
			}
			.block {
				flex-flow: row wrap;
				align-items: center;
				justify-content: center;
				max-width: 90vw;

				margin: 0;
				img {
					width: 80vw;
				}

				.info {
					max-width: 90vw;
					div h2 {
						font-size: 18px;
					}
					ul {
						gap: 8px;
						li {
							font-size: 14px;
						}
					}
				}
			}
		}

		.maps {
			width: calc(100vw - 40px);
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin: 0;
			padding: 0;
			h3 {
				align-self: self-start;
			}
			a {
				font-size: 14px;
			}

			iframe {
				width: calc(100vw - 20%);
				height: auto;

				-webkit-box-shadow: -2px -1px 20px 3px rgba(60, 255, 150, 0.27);
				-moz-box-shadow: -2px -1px 20px 3px rgba(60, 255, 150, 0.27);
				box-shadow: -2px -1px 20px 3px rgba(60, 255, 150, 0.27);
			}
		}
	}

	@media (max-width: 380px) {
		.Slogan-wrapper {
			img {
				max-width: 80vw;
			}
		}
		.top-content {
			p {
				width: 98%;
			}
			span {
				strong {
					white-space: normal;
					text-align: center;
					line-height: 30px;
				}
			}

			.mid_info-area {
				max-width: 98%;
				justify-content: center;
				p {
					width: 98%;
				}

				ul {
					gap: 20px;
				}
				li {
					p {
						text-align: left;
						font-size: 16px;
					}
					align-items: center;
					svg {
						font-size: 25px;
					}
				}
			}
		}

		.info-area {
			h1,
			h1 > strong {
				font-size: 24px;
			}

			h1 > span {
				font-size: 15px;
			}
		}
	}
`;
export const Wrapper = styled.div`
	width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	padding: 30px;
	gap: 60px;

	@media (max-width: 899px) {
		padding: 10px;
		width: 100vw;
	}

	@media (max-width: 680px) {
		padding: 10px;
		width: 100vw;
	}

	@media (max-width: 380px) {
		padding: 10px;
		width: 100vw;
	}
`;
